import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ExpenseItem } from './expense-item.model';

export const getExpenseItems = createAction(
  '[ExpenseItem/API] GET ExpenseItems',
);

// export const postExpenseItems = createAction(
//   '[ExpenseItem/API] POST ExpenseItems',
//   props<{ }>()
// );

export const putExpenseItems = createAction(
  '[ExpenseItem/API] PUT ExpenseItems',
  props<{ expenseItems: Array<ExpenseItem>}>()
);

export const loadExpenseItems = createAction(
  '[ExpenseItem/API] Load ExpenseItems',
  props<{ expenseItems: ExpenseItem[] }>()
);

export const addExpenseItem = createAction(
  '[ExpenseItem/API] Add ExpenseItem',
  props<{ expenseItem: ExpenseItem }>()
);

export const upsertExpenseItem = createAction(
  '[ExpenseItem/API] Upsert ExpenseItem',
  props<{ expenseItem: ExpenseItem }>()
);

export const addExpenseItems = createAction(
  '[ExpenseItem/API] Add ExpenseItems',
  props<{ expenseItems: ExpenseItem[] }>()
);

export const upsertExpenseItems = createAction(
  '[ExpenseItem/API] Upsert ExpenseItems',
  props<{ expenseItems: ExpenseItem[] }>()
);

export const updateExpenseItem = createAction(
  '[ExpenseItem/API] Update ExpenseItem',
  props<{ expenseItem: Update<ExpenseItem> }>()
);

export const updateExpenseItems = createAction(
  '[ExpenseItem/API] Update ExpenseItems',
  props<{ expenseItems: Update<ExpenseItem>[] }>()
);

export const deleteExpenseItem = createAction(
  '[ExpenseItem/API] Delete ExpenseItem',
  props<{ id: string }>()
);

export const deleteExpenseItems = createAction(
  '[ExpenseItem/API] Delete ExpenseItems',
  props<{ ids: string[] }>()
);

export const clearExpenseItems = createAction(
  '[ExpenseItem/API] Clear ExpenseItems'
);
